import { CustomCard, RequestedCard } from '@/interfaces/cards';
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import type { RootState } from '@/app/store';
import cardsServices from '@/api/cardsService';

const tempData = [
  {
    id: '4343',
    cardType: 'DEBIT',
    accountNumber: '207254589632-47',
    accHolderName: 'Anni',
    address: 'Cameroon, Yaoundé, Avenue Kennedy, 15',
    email: 'anni@gmail.com',
    status: 'denied',
  },
];

interface MetaData {
  totalPages: number;
  page: number;
  totalElements: number;
}

interface CardsState {
  requestedCards: { [key: string]: RequestedCard[] };
  currFilters: string;
  metaData: { [key: string]: MetaData };
  loading: boolean;
  customCards: CustomCard[];
}

const initialState: CardsState = {
  requestedCards: {},
  currFilters: '',
  metaData: {},
  loading: false,
  customCards: [],
};

export const fetchRequestedCards = createAsyncThunk('cards/fetch', async ({ size, page }: { size: number; page: number }, thunkAPI) => {
  try {
    const result = tempData;
    return result;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.data);
  }
});

export const fetchCustomCards = createAsyncThunk('customCards/fetch', async (_, thunkAPI) => {
  try {
    const result = await cardsServices.getCustomCards({ size: 1000, page: 0, status: 'ACTIVE' });
    return result;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.data);
  }
});

export const cardsSlice = createSlice({
  name: 'cards',
  initialState,
  reducers: {
    handleParamsChange: (state, action: PayloadAction<{ size: number; page: number }>) => {
      const filters = JSON.stringify(action.payload);
      state.currFilters = filters;
    },
    refreshCardsState: () => initialState,
    refreshRequestedCards: state => {
      state.requestedCards = {};
    },
    setCustomCardDesign: (state, action: PayloadAction<{ id: string; url: string }>) => {
      const { id, url } = action.payload;
      state.customCards = state.customCards.map((card: CustomCard) => {
        return card.id === id ? { ...card, design: { ...card.design, name: url } } : card;
      });
    },
  },

  extraReducers: builder => {
    builder.addCase(fetchRequestedCards.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchRequestedCards.fulfilled, (state, action) => {
      const { payload, meta } = action;
      const { size, page } = meta.arg;
      const stringifyFilters = JSON.stringify({ size, page });
      state.requestedCards[stringifyFilters] = payload;
      state.metaData[stringifyFilters] = {
        totalPages: 1,
        totalElements: 1,
        page: 1,
      };
      state.requestedCards[state.currFilters] = action.payload;
      state.loading = false;
    });

    builder.addCase(fetchRequestedCards.rejected, state => {
      state.loading = false;
    });

    builder.addCase(fetchCustomCards.fulfilled, (state, action) => {
      state.customCards = action.payload.data;
    });
  },
});

export const { handleParamsChange, refreshRequestedCards, setCustomCardDesign, refreshCardsState } = cardsSlice.actions;

export const selectCards = (state: RootState) => state.cards;

export default cardsSlice.reducer;
